import { ComponentProps } from 'react'
import * as Components from '../components'
import * as Stores from '../stores'

export function useOnboardingChecklistPlatform() {
  const { data: awardQueryResult } = Stores.MortgageEarnApi.endpoints[
    'GET /mortgage/earn'
  ].useQuery({}, { refetchOnMountOrArgChange: true })

  if (!awardQueryResult) {
    return 'loading'
  }

  const { latestMonthlyAward, activeMonthlyAward } = awardQueryResult
  const { awardAmountInPoints: latestAwardAmount } = latestMonthlyAward
  const { awardAmountInPoints: activeAwardAmount } = activeMonthlyAward ?? {}
  const isProgramEnrolled = Boolean(activeAwardAmount || latestAwardAmount)

  const status = (() => {
    if (!isProgramEnrolled) {
      return 'unenrolled' as const
    }

    switch (latestMonthlyAward.status) {
      case 'PENDING':
        return 'in_review' as const
      case 'UPLOAD_REQUIRED':
        return 'needs_upload' as const
      case 'ACCEPTED':
        return 'complete' as const
      case 'REJECTED':
        return 'rejected' as const
      default:
        latestMonthlyAward.status satisfies never
        return 'complete' as const
    }
  })()

  return {
    awardAmountInPoints: activeAwardAmount ?? 0,
    periodEnd: awardQueryResult.progress.statementCloseDate,
    status,
  } as const satisfies ComponentProps<typeof Components.OnboardingChecklistItem>
}
